// This service saves all of the completed campaign steps and sends it to api.

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProcessCampaignService {

  campaignDetails = {}
  recipients = {}
  messages = {}
  schedule = {}

  constructor() { }


}
